import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Color } from "@tools";

/**
 * Given a background color, will provide a contrasting foreground color as a hex code
 */
@NgFilter({
    token: Token.SmartColorFilter,
    dependencies: [
    ]
})
export class SmartColorFilter {
    constructor() {
        return ((backgroundHex: string) => {
            let color: Color;
            let background: Color = new Color(backgroundHex);
            if (background.isDark()) {
                color = new Color({ r: 250, g: 250, b: 250 });
            } else {
                color = new Color({ r: 17, g: 17, b: 17 });
            }
            return color.toHexString();
        }) as any;
    }
}
